import {$KTS, KeyTextStrings} from "@/shared/types";
import {BaseFragment} from "../shared/BaseFragment";
import {ModuleMain as HomeModuleMain} from "./home/ModuleMain";
import {ModuleMain as LabelerModuleMain} from "./labeler/ModuleMain";
import {SvgIcon} from "@mui/material";
import {HomeOutlined, WorkspacesOutlined} from "@mui/icons-material";

export enum ModuleCategory {
  GENERAL = "general",
  PROJECT = "project",
}

export const MODULE_CATEGORY_KTS = new KeyTextStrings([
  $KTS(ModuleCategory.GENERAL, "General"),
  $KTS(ModuleCategory.PROJECT, "Project"),
]);


export type Module = {
  MainFragment: typeof BaseFragment<any, any>,
  name: string,
  text: string,
  iconType: typeof SvgIcon,
  category: ModuleCategory,
}

export const MODULES: Module[] = [
  {
    MainFragment: HomeModuleMain,
    name: "home",
    text: "Home",
    iconType: HomeOutlined,
    category: ModuleCategory.GENERAL,
  },
  {
    MainFragment: LabelerModuleMain,
    name: "labeler",
    text: "Labeler",
    iconType: WorkspacesOutlined,
    category: ModuleCategory.PROJECT,
  },
];
